import ApiClient from './ApiClient';

export default class ConfigApi extends ApiClient {
  /**
   * @param regionName
   * @returns {
   *  "redirect_uri": "https://omsk.cian.ru/"
   * }
   */
  fetchCianRedirectUrl (regionName) {
    return this.get(`${this.prefix}cian/redirect?domain=${regionName}.mlsn.ru`);
  }
}



// WEBPACK FOOTER //
// ./src/api/ConfigApi.js